<template>
  <div>
    <div id="close-setting">
      <b-icon @click.native="$router.push('/settings')" class="hoverable" icon="close-circle" />
    </div>
    <h1 class="title is-4">Opleiding</h1>
    <hr />
    <div class="block">Je opleiding wordt gebruikt om sneller woordenlijsten te maken en zoeken.</div>
    <div class="content">
      <div class="columns">
        <div class="column">
          <b-field label="Leerjaar">
            <b-select size="is-medium" v-model="user.year" placeholder="Selecteer je jaar" expanded="expanded">
              <option :key="n" v-for="n in 10" :value="n">{{ n }}</option>
              <option value="anders">Anders</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Opleiding">
            <b-select size="is-medium" expanded v-model="user.level">
              <option :key="level" v-for="level in educationLevels" :value="level">{{ level | ucfirst }}</option>
              <option value="anders">Anders</option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <hr />
    <b-button @click="saveEducation()" size="is-medium" class="is-pulled-right" type="is-success">Opslaan</b-button>
  </div>
</template>
<script>
import ApiService from "@/common/api.service";

export default {
  data() {
    return {
      user: {
        year: this.$store.state.user.year,
        level: this.$store.state.user.level,
      },
    };
  },
  methods: {
    async saveEducation() {
      let response = await ApiService.post("user/update", {
        year: this.user.year,
        level: this.user.level,
      });

      this.$gtag.event("change_education", {
        event_category: "user",
        value: 1,
      });

      return this.$buefy.toast.open({
        message: "Je opleidingsinstellingen zijn aangepast",
        type: "is-success",
        position: "is-bottom-right",
      });
    },
  },
  computed: {
    educationLevels() {
      return this.$store.state.app.educationLevels;
    },
  },
};
</script>
<style lang="scss" scoped>
#close-setting {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
}
@media only screen and (max-width: 1200px) {
  #close-setting {
    display: block;
  }
}
</style>
